<template>
  <div>
    <div class="NCAcmi_familyN padBSM padTSM">
      <div class="floL">
        <label for="NCAcmi_family_file02-2">
          <em class="disIb">추가금액 정보<span class="ico-must-astar"></span></em>
        </label>
      </div>
      <div class="floR txtR">
        <template v-if="paymentInfo">
          <div class="fntP"><em>{{ getPaymentMethodText(paymentInfo.paymentMethod) }}</em></div>
        </template>
        <template v-else>
          <div class="NCAcmi_familyN_fileWrap">
            <span
              class="fntP NCAcmi_familyN_file"
              style="cursor: pointer;"
              @click="openPaymentInfoPopup"
            ><a style="color:#fff;">결제정보 입력</a></span>
          </div>
        </template>
      </div>
    </div>

    <template v-if="paymentInfo">
      <div class="NCAcmi_familyN">
        <div class="floL">
        </div>
        <div class="floR txtR">
          <div class="NCAcmi_familyN_fileWrap">
            <span
              class="fntP NCAcmi_familyN_file"
              style="background:#808285; cursor: pointer;"
              @click="openPaymentInfoPopup"
            ><a style="color:#fff;">{{ disabled ? '결제정보 확인' : '결제정보 수정' }}</a></span>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { CommonMethodMixin } from '../mixins'
import SurveyPopupPaymentInfo from './SurveyPopupPaymentInfo.vue'

export default {
  name: 'SurveyParticipantPayment',
  mixins: [CommonMethodMixin],
  props: {
    paymentInfo: {
      type: Object,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    resIdx: {
      type: Number,
      required: true
    }
  },
  methods: {
    openPaymentInfoPopup() {
      this.openPopupLayer({
        headerText: this.disabled ? '결제정보' : '결제정보 입력',
        component: SurveyPopupPaymentInfo,
        props: { idx: this.resIdx, disabled: this.disabled }
      });
    }
  },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/survey2/components/SurveyParticipantPayment.vue